"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldNumber = void 0;
var RootClass = require("./rootClass");
var FieldNumber = (function (_super) {
    __extends(FieldNumber, _super);
    function FieldNumber(typeObj, jSonDoc, srvType) {
        if (srvType === void 0) { srvType = 1; }
        var _this = this;
        if (typeObj !== "number") {
            throw new Error("wrong objectType for a number field");
        }
        _this = _super.call(this, typeObj, jSonDoc, srvType) || this;
        return _this;
    }
    FieldNumber.prototype.encode = function (jSonData) {
        return _super.prototype.encode.call(this, jSonData);
    };
    FieldNumber.prototype.decode = function () {
        return _super.prototype.decode.call(this);
    };
    FieldNumber.prototype.toClass = function () {
        return this;
    };
    FieldNumber.prototype.setProp = function (propName, value) {
        return _super.prototype.setProp.call(this, propName, value);
    };
    FieldNumber.prototype.save = function () {
        return _super.prototype.save.call(this, 0);
    };
    FieldNumber.prototype.changeToLinkedField = function (ptId, remoteEntity, remoteField, verbFrom, verbTo, remoteEntityName, remoteFieldSingular, maxLength, lfUiType) {
        var _this = this;
        if (ptId === void 0) { ptId = -1; }
        if (remoteEntity === void 0) { remoteEntity = -1; }
        if (remoteField === void 0) { remoteField = -1; }
        if (verbFrom === void 0) { verbFrom = ""; }
        if (verbTo === void 0) { verbTo = ""; }
        if (remoteEntityName === void 0) { remoteEntityName = ""; }
        if (remoteFieldSingular === void 0) { remoteFieldSingular = ""; }
        if (maxLength === void 0) { maxLength = -1; }
        if (lfUiType === void 0) { lfUiType = "linkedField"; }
        if (["linkedField", "lookup"].indexOf(lfUiType) === -1) {
            throw new Error("invalid parameter " + lfUiType);
        }
        var updatePt = ptId === -1 ? true : false;
        var fieldCNUsingThisTemplate = -1;
        this.myApi.entities.getAllEntities().forEach(function (anEntity) {
            anEntity.fields.forEach(function (aField) {
                if (aField.systemType === "linkedField") {
                    var aLFi = aField;
                    if (aLFi.isFieldUsedInTemplate(_this.id)) {
                        fieldCNUsingThisTemplate = aField.id;
                    }
                    if (aLFi.linkedRelation[0] === ptId) {
                        updatePt = false;
                    }
                }
                if (aField.systemType === "rollup") {
                    var aRolFi = aField;
                    if (aRolFi.rolFCN === _this.id) {
                        fieldCNUsingThisTemplate = aField.id;
                    }
                }
            });
        });
        if (fieldCNUsingThisTemplate !== -1) {
            throw new Error("This field is used in linkedField/rollup: " + fieldCNUsingThisTemplate);
        }
        var opts = "rcn=" + ptId + "&reCN=" + remoteEntity + "&rfCN=" + remoteField +
            "&verbFrom=" + verbFrom + "&verbTo=" + verbTo + "&reEntName=" + remoteEntityName +
            "&reFieldSing=" + remoteFieldSingular +
            "&maxLen=" + maxLength + "&updatePt=" + updatePt + "&lfUIType=" + lfUiType + "&srcType=number";
        return this.myApi.restApi.promoteToFi(this.eCN, this.id, opts);
    };
    FieldNumber.prototype.postProcess = function () {
        _super.prototype.postProcess.call(this);
        if (this.jSonCN !== -1) {
            var myEntiti = this.myApi.entities.getByEcn(this.eCN);
            if (myEntiti !== null) {
                var jSonField = myEntiti.getField(this.jSonCN);
                if (jSonField !== null) {
                    jSonField.postProcess();
                }
            }
        }
    };
    return FieldNumber;
}(RootClass.RootClass));
exports.FieldNumber = FieldNumber;
